var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignmentBottomSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1568_1243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7812 14.0909H4.21875C4.09443 14.0909 3.9752 14.0431 3.88729 13.9578C3.79939 13.8726 3.75 13.7569 3.75 13.6364C3.75 13.5158 3.79939 13.4002 3.88729 13.315C3.9752 13.2297 4.09443 13.1819 4.21875 13.1819H10.7812C10.9056 13.1819 11.0248 13.2297 11.1127 13.315C11.2006 13.4002 11.25 13.5158 11.25 13.6364C11.25 13.7569 11.2006 13.8726 11.1127 13.9578C11.0248 14.0431 10.9056 14.0909 10.7812 14.0909Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83151 12.1396C7.7436 12.2248 7.62439 12.2727 7.5001 12.2727C7.3758 12.2727 7.2566 12.2248 7.16869 12.1396L4.35619 9.41235C4.27081 9.32662 4.22356 9.2118 4.22463 9.09262C4.2257 8.97344 4.27499 8.85943 4.3619 8.77516C4.44881 8.69088 4.56638 8.64308 4.68929 8.64204C4.81219 8.64101 4.9306 8.68682 5.01901 8.76962L7.03135 10.721V1.81826C7.03135 1.6977 7.08074 1.58209 7.16864 1.49684C7.25655 1.4116 7.37578 1.36371 7.5001 1.36371C7.62442 1.36371 7.74365 1.4116 7.83156 1.49684C7.91946 1.58209 7.96885 1.6977 7.96885 1.81826V10.721L9.98119 8.76962C10.0696 8.68682 10.188 8.64101 10.3109 8.64204C10.4338 8.64308 10.5514 8.69088 10.6383 8.77516C10.7252 8.85943 10.7745 8.97344 10.7756 9.09262C10.7766 9.2118 10.7294 9.32662 10.644 9.41235L7.83151 12.1396Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1568_1243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignmentBottomSmall);
export default __webpack_public_path__ + "static/media/alignment-bottom-small.06e7229f6b733488d279767df53fe019.svg";
export { ForwardRef as ReactComponent };